import { Navigate, Route, Routes } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { AdminLayout } from "@/components/AdminLayout";
import { HomePage } from "@/pages/HomePage";
import { IntakePage } from "@/pages/IntakePage";
import { EventsPage } from "@/pages/EventsPage";
import { EventRegistrationPage } from "@/pages/EventRegistrationPage";
import { AdminOverview } from "@/pages/admin/AdminOverview";
import { ProfilesPage } from "@/pages/admin/ProfilesPage";
import { FormsAdminPage } from "@/pages/admin/FormsAdminPage";
import { EventsAdminPage } from "@/pages/admin/EventsAdminPage";
import { DistributionsAdminPage } from "@/pages/admin/DistributionsAdminPage";
import { CommunicationsPage } from "@/pages/admin/CommunicationsPage";
import { UsersAdminPage } from "@/pages/admin/UsersAdminPage";

export default function App() {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/connect" element={<IntakePage />} />
        <Route path="/form/neighbor-signup" element={<IntakePage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:slug" element={<EventRegistrationPage />} />
      </Route>
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminOverview />} />
        <Route path="profiles" element={<ProfilesPage />} />
        <Route
          path="import"
          element={<Navigate to="/admin/profiles" replace />}
        />
        <Route path="forms" element={<FormsAdminPage />} />
        <Route path="events" element={<EventsAdminPage />} />
        <Route path="distributions" element={<DistributionsAdminPage />} />
        <Route path="communications" element={<CommunicationsPage />} />
        <Route path="users" element={<UsersAdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
